import {
  SkeletonPage,
  Layout,
  Card,
  BlockStack,
  SkeletonBodyText,
  SkeletonDisplayText,
} from "@shopify/polaris";

/**
 * Loading placeholder for the file view page. Mirrors the real two-column
 * layout (comments / related files on the left, details / review / signature
 * on the right) so the page does not jump once data arrives.
 */
export default function FileViewSkeleton() {
  return (
    <SkeletonPage fullWidth primaryAction={false} backAction>
      <Layout>
        <Layout.Section>
          <BlockStack gap="500">
            {/* Comments */}
            <Card roundedAbove="sm">
              <BlockStack gap="300">
                <SkeletonDisplayText size="small" />
                <SkeletonBodyText lines={3} />
              </BlockStack>
            </Card>
            {/* Related files */}
            <Card roundedAbove="sm">
              <BlockStack gap="300">
                <SkeletonDisplayText size="small" />
                <SkeletonBodyText lines={4} />
              </BlockStack>
            </Card>
          </BlockStack>
        </Layout.Section>
        <Layout.Section variant="oneThird">
          <BlockStack gap="500">
            {/* Details */}
            <Card roundedAbove="sm">
              <BlockStack gap="300">
                <SkeletonDisplayText size="small" />
                <SkeletonBodyText lines={9} />
              </BlockStack>
            </Card>
            {/* Review by */}
            <Card roundedAbove="sm">
              <BlockStack gap="300">
                <SkeletonDisplayText size="small" />
                <SkeletonBodyText lines={2} />
              </BlockStack>
            </Card>
          </BlockStack>
        </Layout.Section>
      </Layout>
    </SkeletonPage>
  );
}
